// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3CHXm","inputWrap":"styles_inputWrap__2qMEA","input":"styles_input__xgOS6"};